import React, { createContext, useState, useContext, useEffect, useCallback } from 'react'

const RefreshContext = createContext(null)

export const useRefresh = () => useContext(RefreshContext)

export const useRegisterRefresh = (handler) => {
  const { setRefreshHandler } = useRefresh()

  useEffect(() => {
    setRefreshHandler(() => handler)

    return () => setRefreshHandler(null)
  }, [handler, setRefreshHandler])
}

export const useDrawerOpen = (open) => {
  const { registerDrawerOpen } = useRefresh()

  useEffect(() => {
    if (open) {
      const unregister = registerDrawerOpen()
      return unregister
    }
  }, [open, registerDrawerOpen])
}

export const RefreshProvider = ({ children }) => {
  const [refreshHandler, setRefreshHandler] = useState(null)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const registerDrawerOpen = useCallback(() => {
    setIsDrawerOpen(true)
    return () => setIsDrawerOpen(false)
  }, [])

  return (
    <RefreshContext.Provider value={{
      refreshHandler,
      setRefreshHandler,
      registerDrawerOpen,
      isDrawerOpen,
    }}>
      {children}
    </RefreshContext.Provider>
  )
}